import React from 'react'

import { UnknownObject } from 'src/utils/reactTypes'

export const LinkIcon: React.FC<UnknownObject> = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.1665 11.9167C9.56017 12.443 10.0624 12.8785 10.6392 13.1936C11.2159 13.5087 11.8537 13.6961 12.5093 13.743C13.1648 13.79 13.8228 13.6954 14.4386 13.4657C15.0543 13.236 15.6135 12.8765 16.0782 12.4117L18.8282 9.66172C19.6631 8.79729 20.125 7.63953 20.1146 6.43779C20.1042 5.23606 19.6221 4.0865 18.7723 3.23671C17.9226 2.38693 16.773 1.9049 15.5713 1.89446C14.3695 1.88402 13.2118 2.34599 12.3473 3.18088L10.7707 4.74838"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8335 10.0834C12.4399 9.55709 11.9376 9.12163 11.3608 8.80652C10.7841 8.4914 10.1463 8.30402 9.49075 8.25707C8.83521 8.21012 8.17723 8.30471 7.56145 8.53441C6.94567 8.76411 6.3865 9.12356 5.92185 9.58838L3.17185 12.3384C2.33696 13.2028 1.87498 14.3606 1.88543 15.5623C1.89587 16.764 2.37789 17.9136 3.22768 18.7634C4.07747 19.6132 5.22703 20.0952 6.42876 20.1056C7.6305 20.1161 8.78826 19.6541 9.65268 18.8192L11.2202 17.2517"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
